import { Bleed } from '@cellula/react';
import { useWindowSize } from '@visiba/react-std';
import { Shimmer } from '@components/shimmer.component';
import { ReceptionHomeLayout } from './_reception_home_layout.component';

export function ReceptionHomeSkeleton(): JSX.Element {
	const { width } = useWindowSize();
	const uniqueButtonsComponents: JSX.Element[] = [
		<Shimmer height={146} width={349} cornerRadius={8} key={1} />,
		<Shimmer height={146} width={349} cornerRadius={8} key={2} />,
		<Shimmer height={146} width={349} cornerRadius={8} key={3} />,
	];

	return (
		<ReceptionHomeLayout
			heroSection={
				<Bleed viewportWide>
					<Shimmer height={294} width={width ?? 1096} cornerRadius={8} />
				</Bleed>
			}
			actionSection={uniqueButtonsComponents}
			aboutUsSection={null}
			footerSection={null}
		></ReceptionHomeLayout>
	);
}
